define('drops/carouselControl/carouselControl',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style'
], function ($, lq, Drop, Style) {
    'use strict';

    function CarouselControl(options) {
        Drop.call(this, $('<div/>'), options);

        Style.renderStyles(this);

        this.$element
            .addClass('clickable')
            .on('click', this.clicked.bind(this))
            .css('background-size', 'cover');

        this.onChangeListener = this.updateVisibility.bind(this);
    };

    Drop.extend(CarouselControl, Drop);

    CarouselControl.typeName = 'CarouselControl';
    
    CarouselControl.prototype.preRender = function () {
        this.applyPosition();
        this.setupControlImages();
        this.updateVisibility();
        
        this.parent.onChange(this.onChangeListener);
    };

    CarouselControl.prototype.clicked = function() {
        this.parent.performAction(this.data.action);
    };

    CarouselControl.prototype.updateVisibility = function () {
        this.$element.toggle(this.parent.canPerformAction(this.data.action));
    };

    CarouselControl.prototype.setupControlImages = function () {
        if (!this.data.normalImage)
            return;

        var normalImage = lq.getTenantUploads(this.data.normalImage);
        this.setImage(normalImage);

        if (!this.data.hoverImage)
            return;

        var hoverImage = lq.getTenantUploads(this.data.hoverImage);
        this.$element
            .on('mouseenter', this.setImage.bind(this, hoverImage))
            .on('mouseleave', this.setImage.bind(this, normalImage));
    };

    CarouselControl.prototype.setImage = function (path) {
        this.$element.css('background-image', 'url(' + path + ')');
    };

    return CarouselControl;
});
